<template>
  <button
    type="button"
    class="og-chatbot-button"
    :class="[
      { 'og-chatbot-button--open': isOpen },
      `og-chatbot-button--${layout || 'popup'}`,
    ]"
    :aria-label="label"
    @click="$emit('click')"
  >
    <i
      v-if="isOpen"
      class="times icon og-chatbot-button__icon"
      aria-hidden="true"
    />
    <i
      v-else
      class="comment icon og-chatbot-button__icon"
      aria-hidden="true"
    />
  </button>
</template>

<script>
export default {
  name: 'ChatbotButton',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Abrir chat',
    },
    layout: {
      type: String,
      default: 'popup',
      validator: (v) => ['popup', 'sidebar'].includes(v || 'popup'),
    },
  },
};
</script>

<style scoped>
/* Eloca theme: $theme-dark-primary #005ec2, $theme-dark-primary-dark #004fa3 */
.og-chatbot-button {
  position: fixed;
  right: 48px;
  bottom: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #005ec2 0%, #004fa3 100%);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.og-chatbot-button:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 94, 194, 0.4);
}

.og-chatbot-button__icon {
  margin: 0 !important;
  opacity: 1;
}

.og-chatbot-button--open .og-chatbot-button__icon {
  font-size: 1.2em;
}

/* Modo sidebar: aba vertical colada à direita */
.og-chatbot-button--sidebar {
  right: 0;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 100px;
  border-radius: 12px 0 0 12px;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
}

.og-chatbot-button--sidebar:hover {
  transform: translateY(-50%) scale(1.02);
}

.og-chatbot-button--sidebar .og-chatbot-button__icon {
  font-size: 20px;
}
</style>
